import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { Masonry } from '@leagueplatform/masonry';
import { MASONRY } from 'common/constants';
import { usePatientPortalMasonryProps } from 'hooks/queries/use-patient-portal-masonry-props.hook';
import { MasonryPageLayout } from 'components/masonry-page-layout/masonry-page-layout.component';

export const LinkedCentresLandingPage = () => {
  usePageViewAnalytics({ screen_name: 'Linked Centres' });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_LINKED_CENTRES' }));
  const masonryProps = usePatientPortalMasonryProps({
    nodeId: MASONRY.ROOT_NODE_LINKED_CENTRES_LANDING_PAGE,
  });

  return (
    <MasonryPageLayout showBackButton>
      <Masonry {...masonryProps} />
    </MasonryPageLayout>
  );
};
